import React from 'react'
import PropTypes from 'prop-types'
import { TableRow, TableCell, Box } from '@mui/material'
import { LoadingSpinner } from '../atoms'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import styles from './TableLoadingState.module.scss'

/**
 * TableLoadingState - A component to display table loading skeletons
 *
 * @param {Object} props - Component props
 * @param {number} props.colSpan - The number of columns in the table
 * @param {number} props.rows - The number of rows to show in the loading state
 * @param {boolean} props.useSpinner - Whether to use a spinner instead of skeletons
 * @param {Array} props.cellWidths - Array of widths for each cell in a row
 */
const TableLoadingState = ({
  colSpan = 1,
  rows = 5,
  useSpinner = false,
  cellWidths = []
}) => {
  if (useSpinner) {
    return (
      <TableRow className={styles.tableRow}>
        <TableCell colSpan={colSpan} className={styles.tableCell}>
          <Box className={styles.circularProgressContainer}>
            <LoadingSpinner />
          </Box>
        </TableCell>
      </TableRow>
    )
  }

  const getSkeletonWidth = (cellIndex) => {
    if (cellWidths && cellWidths[cellIndex]) {
      return cellWidths[cellIndex]
    }
    const widths = [140, 100, 180, 120, 160, 90, 150, 110, 170, 130]
    return widths[cellIndex % widths.length]
  }

  return (
    <>
      {Array.from(new Array(rows)).map((_, rowIndex) => (
        <TableRow key={`skeleton-row-${rowIndex}`} className={styles.tableRow}>
          {Array.from(new Array(colSpan)).map((_, cellIndex) => (
            <TableCell key={`skeleton-cell-${rowIndex}-${cellIndex}`} className={styles.tableCell}>
              <Box className={styles.skeletonContainer}>
                <Skeleton width={getSkeletonWidth(cellIndex)} height={30} />
              </Box>
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  )
}

TableLoadingState.propTypes = {
  colSpan: PropTypes.number,
  rows: PropTypes.number,
  useSpinner: PropTypes.bool,
  cellWidths: PropTypes.arrayOf(PropTypes.number)
}

export default TableLoadingState
